/**
 * @name PreferencesService
 * @constructor
 */
export function PreferencesService(Preference, UserService) {
  this.preferences = [];
  this.status = {
    loading: 0,
  };

  const self = this;

  this.updatePreference = function(preference) {
    return Preference.update(
      { name: preference.name },
      { selected: (preference.selected == true) }
    ).$promise
      .then(function() {
        return UserService.fetchUser();
      });
  };

  this.fetchPreferences = function() {
    self.status.loading++;

    return Preference.query().$promise
      .then(function(preferences) {
        self.preferences.length = 0;

        preferences.forEach(function(preference) {
          if(preference.hidden) return;
          if(preference.title)
            preference.title = preference.title.charAt(0).toUpperCase() + preference.title.slice(1);

          self.preferences.push(preference);
        });

        self.status.loading--;
      })
      .catch(function(err) {
        console.error("Error fetching preferences: ", err);

        self.status.loading--;
      });
  };
};

export default [
  'PreferenceResource',
  'UserService',
  PreferencesService
];